<ng-container [ngSwitch]="field.name">
    <ng-container *ngSwitchCase="'primaryColor'">
        <div class="input-cell">
            <div class="input-wrapper-row">
                <div class="input-label">Current:</div>
                <div class="current-value" [ngStyle]="{'background': primaryColor}"></div>
            </div>
        </div>
        <div class="input-cell">
            <div class="input-wrapper-row">
                <nb-radio-group [(value)]="selectedOption" (valueChange)="onChangeOption($event)" #optionPicker>
                    <nb-radio value="preset">Presets</nb-radio>
                    <nb-radio value="custom">Custom</nb-radio>
                </nb-radio-group>
            </div>
            <div class="selected-color-picker">
                <color-sketch [presetColors] ="colors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)" #primaryColorPicker kveToggleSection></color-sketch>
            </div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'background'">
        <div class="input-cell">
            <div class="input-wrapper-row">
                <div class="input-label">Current:</div>
                <div class="current-value" [ngStyle]="{'background': pageBgColor}"></div>
            </div>
        </div>
        <div class="input-cell">
            <div class="input-wrapper-row">
                <nb-radio-group [(value)]="selectedOption" (valueChange)="onChangeOption($event)" #optionPicker>
                    <nb-radio value="preset">Presets</nb-radio>
                    <nb-radio value="custom">Custom</nb-radio>
                </nb-radio-group>
            </div>
            <div class="selected-color-picker">
                <color-sketch [presetColors] ="allColors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)" #primaryColorPicker kveToggleSection></color-sketch>
            </div>
        </div>
        <!-- <nb-tabset>
            <nb-tab tabTitle="Basic">
                <div class="input-cell">
                    <color-github
                        [colors]="allColors"
                        triangle="top-right"
                        (onChangeComplete)="changeComplete($event)"
                        (onChange)="handleBgChange($event)"
                        ></color-github>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Primary">
                <div class="input-cell">
                    <color-github
                    [colors]="primaryColors"
                    triangle="top-right"
                    (onChangeComplete)="changeComplete($event)"
                    (onChange)="handleBgChange($event)"
                    ></color-github>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Dark">
                <div class="input-cell">
                    <color-github
                    [colors]="bgAlt"
                    triangle="top-right"
                    (onChangeComplete)="changeComplete($event)"
                    (onChange)="handleBgChange($event)"
                    ></color-github>
                </div>
            </nb-tab>
        </nb-tabset> -->
        
        
        
        
        <!-- <color-compact
                [colors]="_bgColors"
                (onChangeComplete)="changeComplete($event)"
                (onChange)="changeComplete($event)"
                ></color-compact> -->
        <!-- <div *ngFor="let color of _bgColors"  [ngStyle]="{'background': color,'height':'30px'}"></div> -->
    </ng-container>
    <ng-container *ngSwitchCase="'textColor'">
        <div class="input-cell">
            <div class="selected-color-picker">
                <color-sketch [presetColors] ="allColors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)" #primaryColorPicker kveToggleSection></color-sketch>
            </div> 
        </div>
    </ng-container>        
    <ng-container *ngSwitchCase="'pageBgColor'">
        <div class="input-cell">
            <div class="input-wrapper-row">
                <div class="input-label">Current:</div>
                <div class="current-value" [ngStyle]="{'background': pageBgColor}"></div>
            </div>
        </div>
        <nb-tabset>
            <nb-tab tabTitle="Basic">
                <div class="input-cell">
                    <color-github
                        [colors]="bgBasic"
                        triangle="top-right"
                        (onChangeComplete)="changeComplete($event)"
                        (onChange)="handleBgChange($event)"
                      ></color-github>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Primary">
                <div class="input-cell">
                    <color-github
                    [colors]="_primaryColors"
                    triangle="top-right"
                    (onChangeComplete)="changeComplete($event)"
                    (onChange)="handleBgChange($event)"
                  ></color-github>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Dark">
                <div class="input-cell">
                    <color-github
                    [colors]="bgAlt"
                    triangle="top-right"
                    (onChangeComplete)="changeComplete($event)"
                    (onChange)="handleBgChange($event)"
                  ></color-github>
                </div>
            </nb-tab>
        </nb-tabset>
        
        
        
        
        <!-- <color-compact
                [colors]="_bgColors"
                (onChangeComplete)="changeComplete($event)"
                (onChange)="changeComplete($event)"
              ></color-compact> -->
        <!-- <div *ngFor="let color of _bgColors"  [ngStyle]="{'background': color,'height':'30px'}"></div> -->
    </ng-container>
    <ng-container *ngSwitchCase="'layoutTextColor'">
        <div class="input-cell">
            <div class="input-wrapper-row">
                <div class="input-label">Current:</div>
                <div class="current-value" [ngStyle]="{'background': textColor}"></div>
            </div>
        </div>
        <nb-tabset>
            <nb-tab tabTitle="Basic">
                <div class="input-cell">
                    <color-github
                        [colors]="bgBasic"
                        triangle="top-right"
                        (onChangeComplete)="changeComplete($event)"
                        (onChange)="handleTxtChange($event)"
                      ></color-github>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Primary">
                <div class="input-cell">
                    <color-github
                    [colors]="_primaryColors"
                    triangle="top-right"
                    (onChangeComplete)="changeComplete($event)"
                    (onChange)="handleTxtChange($event)"
                  ></color-github>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Dark">
                <div class="input-cell">
                    <color-github
                    [colors]="bgAlt"
                    triangle="top-right"
                    (onChangeComplete)="changeComplete($event)"
                    (onChange)="handleTxtChange($event)"
                  ></color-github>
                </div>
            </nb-tab>
        </nb-tabset>

    </ng-container>
</ng-container>
<!-- <ng-container *ngIf="field?.name == 'primaryColor';else bgColors">
    <div class="input-cell">
        <div class="input-wrapper-row">
            <div class="input-label">Current Value:</div>
            <div class="current-value" [ngStyle]="{'background': color}"></div>
        </div>
    </div>
    <div class="input-cell">
        <div class="input-wrapper-row">
            <nb-radio-group [(value)]="selectedOption" (valueChange)="onChangeOption($event)" #optionPicker>
                <nb-radio value="preset">Presets</nb-radio>
                <nb-radio value="custom">Custom</nb-radio>
            </nb-radio-group>
        </div>
        <div class="selected-color-picker">
            <color-sketch [presetColors] ="colors" [color]="color" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)" #primaryColorPicker></color-sketch>
        </div>
    </div>
</ng-container>
<ng-template #bgColors>
    <ng-container *ngIf="">

    </ng-container>
    <div *ngFor="let color of _bgColors"  [ngStyle]="{'background': color,'height':'30px'}"></div>  
</ng-template> -->
